import React from 'react';

import Api from '../../helpers/api';
import { pageProps } from '../../helpers/propTypes';
import StaticPage from '../../components/pages/page/[slug]/Index';
import { isBrowser } from '../../helpers/environment';
import Storage from '../../helpers/storage';
import {
  STORAGE_SETTINGS,
  SITE_INFO_NAVBAR,
  SITE_INFO_SETTINGS,
} from '../../helpers/constants';

export default class StaticPageWrapper extends React.Component {
    static propTypes = {
      page: pageProps.isRequired,
    }

    static getInitialProps = async ({ req, query }) => {
      const api = new Api({ domain: req ? req.headers.host : null });
      const page = await api.getPage(query.slug);
      const cachedSiteInfo = {
        settings: isBrowser() ? Storage.get(STORAGE_SETTINGS) : null,
        navbar: null,
      };

      const items = [SITE_INFO_SETTINGS, SITE_INFO_NAVBAR].filter((item) => !cachedSiteInfo[item]);
      const siteInfo = {
        ...cachedSiteInfo,
        ...await api.getSiteInfo(items),
      };

      return {
        ...siteInfo,
        page,
      };
    }

    render() {
      return <StaticPage {...this.props} />;
    }
}
